import React from "react";

import { homePath } from "../../../../managerStore";
import logo from "../../../../assets/images/enageed_logo.png";

import styles from "./LoginHeader.module.scss";

export interface LoginHeaderProps {
  school_name: string;
}

export const LoginHeader = (props: LoginHeaderProps) => {
  return (
    <nav className={styles.navHeader}>
      <div>
        <a href={homePath} className={styles.logoLink}>
          <img src={logo} alt="logo" />
        </a>
      </div>
      <div className={styles.description}>ENAGEEDサービス学校管理者画面</div>
      <div className={styles.schoolName}>{props.school_name}</div>
    </nav>
  );
};

export default LoginHeader;
